import React, { useState, useCallback } from "react";
import { Container, Form, Button } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
// ページファイルと同階層の components/Contact.css を参照
import "../components/Contact.css";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_REGEX = /^[\d\-+()（）\s]+$/;

const FORM_INITIAL = { company: "", name: "", phone: "", email: "", message: "" };

export default function ContactForm() {
  const navigate  = useNavigate();
  const location  = useLocation();

  // 確認ページから戻った場合は入力を保持
  const [formData, setFormData] = useState(location.state || FORM_INITIAL);
  const [errors,   setErrors]   = useState({});

  // ─── 入力ハンドラ ─────────────────────────────────────────────
  const handleChange = useCallback((e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    // フィールド単位でエラーをリアルタイム消去
    setErrors((prev) => ({ ...prev, [e.target.name]: undefined }));
  }, []);

  // ─── バリデーション ────────────────────────────────────────────
  const validate = () => {
    const errs = {};
    if (!formData.company)                         errs.company = "会社名は必須です";
    if (!formData.name)                            errs.name    = "担当者名は必須です";
    if (!formData.phone)                           errs.phone   = "電話番号は必須です";
    else if (!PHONE_REGEX.test(formData.phone))    errs.phone   = "正しい電話番号を入力してください";
    if (!formData.email)                           errs.email   = "メールアドレスは必須です";
    else if (!EMAIL_REGEX.test(formData.email))    errs.email   = "正しいメールアドレスを入力してください";
    return errs;
  };

  // ─── 送信ハンドラ ─────────────────────────────────────────────
  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    navigate("/contact/confirm", { state: formData });
  };

  return (
    <div className="contact-page-wrapper">
      <div id="page-top" />
      <Container className="contact-container">
        <h2>お問い合わせフォーム</h2>

        {/* noValidate: ブラウザのデフォルトバリデーションを無効化 */}
        <Form onSubmit={handleSubmit} noValidate>
          {[
            { label: "会社名（必須）",       name: "company", type: "text" },
            { label: "担当者名（必須）",     name: "name",    type: "text" },
            { label: "電話番号（必須）",     name: "phone",   type: "tel",   placeholder: "例：03-1234-5678" },
            { label: "メールアドレス（必須）", name: "email",  type: "email", placeholder: "例：info@zenkyo.co.jp" },
          ].map(({ label, name, type, placeholder }) => (
            <Form.Group className="mb-3" key={name}>
              <Form.Label>{label}</Form.Label>
              <Form.Control
                type={type}
                name={name}
                value={formData[name]}
                onChange={handleChange}
                isInvalid={!!errors[name]}
                placeholder={placeholder}
              />
              <Form.Control.Feedback type="invalid">{errors[name]}</Form.Control.Feedback>
            </Form.Group>
          ))}

          <Form.Group className="mb-3">
            <Form.Label>お問い合わせ内容</Form.Label>
            <Form.Control
              as="textarea"
              rows={5}
              name="message"
              value={formData.message}
              onChange={handleChange}
            />
          </Form.Group>

          <Button type="submit" className="contact-submit-btn">
            内容確認
          </Button>
        </Form>
      </Container>
    </div>
  );
}